import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, modalsSlice, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	blackListPartnerApi,
	BlackListPartnerModel,
	BlackListPartnerRequestNS,
	blackListPartnerSelector,
	blackListPartnerSlice,
} from 'Pages/pp'
import { FormNames } from 'Constants/FormNames'
import { MODAL_NAME } from 'Constants/ModalName'

function* getAll(action: BlackListPartnerRequestNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		let requestParams = new RequestParams()
		let oldItems = new ResponseCatalog<BlackListPartnerModel>()
		if (clear) {
			yield* put(blackListPartnerSlice.actions.clearAll())
		}
		if (!clear && params?.page !== 1) {
			oldItems = yield* select(blackListPartnerSelector.getAll)
			requestParams = yield* select(blackListPartnerSelector.getRequestParams)
		}
		const res = yield* call(blackListPartnerApi.getAll, params || requestParams)
		const items = new ResponseCatalog<BlackListPartnerModel>(res)
		items.entries = [...oldItems.entries, ...res.entries]
		yield* put(blackListPartnerSlice.actions.setParams(params || requestParams))
		yield* put(blackListPartnerSlice.actions.setAll(items))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getOne(action: BlackListPartnerRequestNS.GetOne) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const res = yield* call(blackListPartnerApi.getOne, action.payload)
		yield* put(blackListPartnerSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* createOne(action: BlackListPartnerRequestNS.CreateOne) {
	try {
		yield* call(blackListPartnerApi.createOne, action.payload)
		yield* put(blackListPartnerSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* put(modalsSlice.actions.hideModal(MODAL_NAME.FORM_BLACK_LIST_PARTNER))
	} catch (error) {
		yield* call(errorHandler, error, FormNames.PARTNER_PROFILE.BLACK_LIST_PARTNER)
	}
}

function* updateOne(action: BlackListPartnerRequestNS.UpdateOne) {
	try {
		yield* call(blackListPartnerApi.updateOne, action.payload.id, action.payload.data)
		yield* put(blackListPartnerSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* put(modalsSlice.actions.hideModal(MODAL_NAME.FORM_BLACK_LIST_PARTNER))
	} catch (error) {
		yield* call(errorHandler, error, FormNames.PARTNER_PROFILE.BLACK_LIST_PARTNER)
	}
}

function* deleteOne(action: BlackListPartnerRequestNS.DeleteOne) {
	try {
		yield* call(blackListPartnerApi.deleteOne, action.payload)
		yield* put(blackListPartnerSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* put(modalsSlice.actions.hideModal(MODAL_NAME.FORM_BLACK_LIST_PARTNER))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createMass(action: BlackListPartnerRequestNS.CreateMass) {
	try {
		yield* call(blackListPartnerApi.createMass, { file: action.payload })
		yield* put(blackListPartnerSlice.actions.getAll({ params: new RequestParams(), clear: true }))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* blackListPartnerSaga() {
	yield* takeLatest(blackListPartnerSlice.actions.getAll.type, getAll)
	yield* takeLatest(blackListPartnerSlice.actions.getOne.type, getOne)
	yield* takeLatest(blackListPartnerSlice.actions.createOne.type, createOne)
	yield* takeLatest(blackListPartnerSlice.actions.updateOne.type, updateOne)
	yield* takeLatest(blackListPartnerSlice.actions.deleteOne.type, deleteOne)
	yield* takeLatest(blackListPartnerSlice.actions.createMass.type, createMass)
}
